import store from 'app/store';

export default (Resource, entity) => store.dispatch(Resource.delete(entity.id));
